import * as React from "react";
import Select from '../../../components/Select';
import LoaderComponent from '../../../components/Loader';
import { useSelector, shallowEqual } from "react-redux";

const ContactRelationShipTypes = (props) => {

    const [contactRelationTypeId, setcontactRelationTypeId] = React.useState("");
    const { buttonLoading } = useSelector(
        (state) => ({
            buttonLoading: state.workkardDetail.buttonLoaders.contactRelationType,
        }),
        shallowEqual
    );

    function selectedCRType(value){ 
        setcontactRelationTypeId(value);
    }
    
    const {contactRelationShipTypeList} =  props;
    const selectOptions = contactRelationShipTypeList && contactRelationShipTypeList.map(data => ({ label: data.text, value: data.id }));
    return (
        <React.Fragment>
            <div className="rowSpaceBetween alignMiddle relationModal">
                    <h1>Contact Relationship</h1> 
                </div>
            <div className="modalBody">

                <Select
                    options={selectOptions}
                    selected={ contactRelationTypeId}
                    onSelect={(value) => selectedCRType(value)}
                    openOnClick={true}
                    iconName="downArrow"
                    styleClass="mb"
                    isOpenRight={false}
                />

                <footer className="rowFlex alignRight">
                    {contactRelationTypeId == "" ? <button className="btn buttonGradient disabled">Confirm</button>
                        :
                        <button
                        className="btn buttonGradient"
                        onClick={() => props.onConfirmClick(contactRelationTypeId)}>
                            {buttonLoading && <LoaderComponent />}
                            <span style={{ visibility: buttonLoading ? "hidden" : "" }}>Confirm</span>
                        </button>
                    }
                    <button className="btn link" onClick={props.onCancelClick}>Cancel</button>
                </footer>

            </div>
        </React.Fragment>
    )
}

export default ContactRelationShipTypes;